import React from 'react';
import {Col, Row} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronRight} from "@fortawesome/free-solid-svg-icons";

export default class Thought extends React.Component {

    render() {

        const {handleChangePage, pagesData} = this.props;

        return <div className={'ilead-tools-group'}>

            <div>
                <Row>
                    <Col sm={12}>Imagining</Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to develop strategic long-term goals</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToDevelopStrategicLongTermGoals']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToDevelopStrategicLongTermGoals')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to be innovative</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToBeInnovative']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToBeInnovative')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to think about problems laterally</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToThinkAboutProblemsLaterally']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToThinkAboutProblemsLaterally')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to reframe problems</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToReframeProblems']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToReframeProblems')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
            </div>

            <div>
                <Row>
                    <Col sm={12}>Discerning</Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to prioritise tasks ready for action</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToPrioritiseTasksReadyForAction']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToPrioritiseTasksReadyForAction')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to make timely decisions</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToMakeTimelyDecisions']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToMakeTimelyDecisions')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to focus on the bigger picture</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToFocusOnTheBiggerPicture']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToFocusOnTheBiggerPicture')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to make complex ideas simple, clear and concise</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToMakeComplexIdeasSimpleClearAndConcise']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToMakeComplexIdeasSimpleClearAndConcise')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to make ethical decisions</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToMakeEthicalDecisions']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToMakeEthicalDecisions')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
            </div>

            <div>
                <Row>
                    <Col sm={12}>Shaping</Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to make reasoned judgements</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToMakeReasonedJudgements']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToMakeReasonedJudgements')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to direct people</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToDirectPeople']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToDirectPeople')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to improve processes</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToImproveProcesses']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToImproveProcesses')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to be confident in your judgement calls</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToBeConfidentInYourJudgementCalls']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToBeConfidentInYourJudgementCalls')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
            </div>

            <div>
                <Row>
                    <Col sm={12}>Challenging</Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to challenge others effectively</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToChallengeOthersEffectively']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToChallengeOthersEffectively')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to balance risk with potential benefits</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToBalanceRiskWithPotentialBenefits']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToBalanceRiskWithPotentialBenefits')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight}/></span>
                    </Col>
                </Row>
            </div>
        </div>;
    }
}